import $ from "../../helpers/leaked-jquery";
import "../../vendor/jquery.textrotator";

$(() => {
    $(".savings-label-wrapper").each(function () {
        const $dummySavingLabel1 = $(this).find(".dummy-savings-label-1");
        const $savingsLabel = $(this).find(".savings-label.rotate");
        $dummySavingLabel1.parent().removeClass("d-none");
        const lengthSavingsLabel1 = $dummySavingLabel1.width();
        const lengthSavingsLabel2 = $(this)
            .find(".dummy-savings-label-2")
            .width();
        $savingsLabel.width(
            `${Math.max(lengthSavingsLabel1, lengthSavingsLabel2)}`,
        );
        $savingsLabel.textrotator({ fadeSpeed: 500, pauseSpeed: 4000 });
        $dummySavingLabel1.parent().addClass("d-none");
    });
});
